var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReactionNeedItNow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 79,
    viewBox: "0 0 78 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.4962 39.665C62.4962 52.4393 52.1405 62.795 39.3661 62.795C26.5918 62.795 16.2361 52.4393 16.2361 39.665C16.2361 26.8906 26.5918 16.5349 39.3661 16.5349C52.1405 16.5349 62.4962 26.8906 62.4962 39.665Z",
    fill: "#EAE5F3",
    stroke: "#D3CAE9",
    strokeWidth: 0.73
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8711 50.7148C44.8711 49.6103 42.4087 48.7148 39.3711 48.7148C36.3335 48.7148 33.8711 49.6103 33.8711 50.7148",
    stroke: "#262626",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8713 31.9431C23.4041 32.6972 25.1758 32.362 26.8286 31.1943C28.4814 30.0266 29.3894 28.4687 28.8566 27.7146",
    stroke: "#262626",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9985 44.7158C33.4614 44.7158 36.2685 41.9086 36.2685 38.4458C36.2685 34.983 33.4614 32.1758 29.9985 32.1758C26.5357 32.1758 23.7285 34.983 23.7285 38.4458C23.7285 41.9086 26.5357 44.7158 29.9985 44.7158Z",
    fill: "#262626"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6615 34.7273C34.0623 35.9211 32.8146 38.6193 30.4271 39.4208C28.0396 40.2223 25.4165 38.8237 25.0157 37.63C24.615 36.4362 25.5881 34.2204 28.2899 33.3133C30.9917 32.4063 33.2607 33.5336 33.6615 34.7273Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6387 41.1981C30.7973 41.6791 30.341 42.262 29.6194 42.4999C28.8979 42.7378 28.1843 42.5408 28.0257 42.0597C27.8671 41.5787 28.3234 40.9959 29.045 40.7579C29.7665 40.52 30.4801 40.7171 30.6387 41.1981Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3698 31.9431C54.837 32.6972 53.0653 32.362 51.4125 31.1943C49.7597 30.0266 48.8517 28.4687 49.3845 27.7146",
    stroke: "#262626",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2143 44.7138C51.6772 44.7138 54.4844 41.9067 54.4844 38.4438C54.4844 34.981 51.6772 32.1738 48.2143 32.1738C44.7515 32.1738 41.9443 34.981 41.9443 38.4438C41.9443 41.9067 44.7515 44.7138 48.2143 44.7138Z",
    fill: "#262626"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8754 34.7273C52.2761 35.921 51.0284 38.6192 48.641 39.4208C46.2535 40.2223 43.6304 38.8236 43.2296 37.6299C42.8288 36.4362 43.8019 34.2204 46.5037 33.3133C49.2055 32.4062 51.4746 33.5335 51.8754 34.7273Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6453 40.5406C50.8039 41.0216 50.3476 41.6045 49.626 41.8424C48.9045 42.0803 48.191 41.8833 48.0323 41.4022C47.8737 40.9212 48.3301 40.3384 49.0516 40.1004C49.7732 39.8625 50.4867 40.0596 50.6453 40.5406Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactionNeedItNow);
export default __webpack_public_path__ + "static/media/reaction_need-it-now.c174ea02805f5c13366f1b398b0c55c3.svg";
export { ForwardRef as ReactComponent };